import React from "react";
// Styles
import styled from "styled-components";
// State
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectMode } from "../app/appSlice";
// Icons
import { Icon } from "@iconify/react";
// Images
import GH from "../images/GH.svg";
// Components
import { Badge, Card } from "react-bootstrap";

// #region styled-components
const StyledCard = styled.div`
  height: 100%;

  .card-custom {
    height: 100%;
    border: var(--border);
    transition: all 0.2s ease-in-out;
    background: ${({ theme }) =>
      theme.name === "light" ? "white" : "#3a3a3a"};
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);

    .card-image {
      height: 200px;
      width: 100%;
      object-fit: contain;
      padding: 1rem;
      background: ${({ theme }) =>
        theme.name === "light" ? "white" : "#555"};
    }

    .card-body {
      padding: 1.5rem;
      display: flex;
      flex-direction: column;
      height: 100%;
      color: ${({ theme }) =>
        theme.name === "light" ? "#333" : "#f0f0f0"};
    }

    .card-title {
      font-size: 1.25rem;
      margin-bottom: 0.75rem;
    }

    .card-text {
      font-size: 0.9rem;
      color: ${({ theme }) =>
        theme.name === "light" ? "#555" : "#ccc"};
      flex-grow: 1;
    }

    .tech-badges {
      margin: 1rem 0;
    }

    .action-buttons {
      margin-top: auto;
    }

    @media (max-width: 768px) {
      min-height: 350px;
      
      .card-image {
        height: 150px;
      }
      
      .card-body {
        padding: 1rem;
      }
      
      .card-title {
        font-size: 1.1rem;
      }
      
      .card-text {
        font-size: 0.85rem;
      }
    }
  }
`;
// #endregion

// #region component
const propTypes = {
  demo: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.node,
  name: PropTypes.string.isRequired,
  technologies: PropTypes.arrayOf(PropTypes.string),
  url: PropTypes.string,
  paper: PropTypes.string
};

const ProjectCard = ({ demo, description, image, name, technologies, url, paper }) => {
  const theme = useSelector(selectMode);

  return (
    <StyledCard>
      <Card
        className={`card-custom ${theme === "light" ? "light" : "dark"}`}
      >
        <Card.Img
          variant="top"
          src={image ? image : GH}
          alt={name}
          className="card-image"
        />
        <Card.Body className="d-flex flex-column card-body">
          <Card.Title className="card-title">{name}</Card.Title>
          <Card.Text className="card-text">{description}</Card.Text>
          <div className="tech-badges">
            {technologies && technologies.map((tech, index) => (
              <Badge
                key={index}
                bg={theme === "light" ? "dark" : "light"}
                text={theme === "light" ? "light" : "dark"}
                className="me-2 mb-2"
              >
                {tech}
              </Badge>
            ))}
          </div>
          <div className="d-flex mt-auto action-buttons">
            {url && (
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className={`btn btn-sm ${
                  theme === "light" ? "btn-outline-dark" : "btn-outline-light"
                } me-2`}
              >
                <Icon icon="icomoon-free:github" /> Code
              </a>
            )}
            {demo && (
              <a
                href={demo}
                target="_blank"
                rel="noopener noreferrer"
                className={`btn btn-sm ${
                  theme === "light" ? "btn-outline-dark" : "btn-outline-light"
                } me-2`}
              >
                <Icon icon="charm:link-external" /> Demo
              </a>
            )}
            {paper && (
              <a
                href={paper}
                target="_blank"
                rel="noopener noreferrer"
                className={`btn btn-sm ${
                  theme === "light" ? "btn-outline-dark" : "btn-outline-light"
                }`}
              >
                <Icon icon="mdi:file-document-outline" /> Paper
              </a>
            )}
          </div>
        </Card.Body>
      </Card>
    </StyledCard>
  );
};

ProjectCard.propTypes = propTypes;
// #endregion

export default ProjectCard;
